// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","724":"d91e9ae9"}[chunkId] + "-" + {"532":"2b3ed99a529fdc5735f8","678":"b3fe3e4bdca499ad6bd6","724":"e5b4faa7edb9b969cb43"}[chunkId] + ".js";
};